import { render, staticRenderFns } from "./ModuleFab.vue?vue&type=template&id=2c513c8f"
import script from "./ModuleFab.vue?vue&type=script&lang=js"
export * from "./ModuleFab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports